"use client";

import { useIsKidAccount } from "@packages/sdk";
import type { ReactNode } from "react";

export type HideFromKidsProps = {
  children: ReactNode;
};

export const HideFromKids = ({ children }: HideFromKidsProps) => {
  const { isKidAccount } = useIsKidAccount();

  if (isKidAccount) return null;

  return <>{children}</>;
};
